// eslint-disable-next-line
import { Module } from 'vuex'

interface IState
{
	maxImages: number
	maxLevels: number
	maxScreens: number
	maxElements: number
	maxProjects: number
	maxAudio: number
	maxImageSize: {
		width: number
		height: number
	},
	maxAudioSize: number	// bytes

	invited?: string[]
	claims?: string[]

	hash?: string	// future safeguard for enforcing the limits
}

const defaultSize = {
	width: 1024,
	height: 1024
}

const module: Module<IState, {}> = {
	namespaced: true,

	state: {
		maxImages: 5,
		maxLevels: 5,
		maxScreens: 5,
		maxElements: 5,
		maxProjects: 3,
		maxAudio: 1,
		maxImageSize: defaultSize,
		maxAudioSize: 1048576
	},

	getters: {
		maxImages: state => state.maxImages || 5,
		maxLevels: state => state.maxLevels || 5,
		maxScreens: state => state.maxScreens || 5,
		maxElements: state => state.maxElements || 5,
		maxProjects: state => state.maxProjects || 3,
		maxAudio: state => state.maxAudio || 1,
		maxImageSize: state => state.maxImageSize || defaultSize,
		maxAudioSize: state => state.maxAudioSize || 1048576
	},

	mutations: {
		setData: (state, data: UserMetaData) => {
			state.maxImages = data.maxImages
			state.maxLevels = data.maxLevels
			state.maxScreens = data.maxScreens
			state.maxElements = data.maxElements
			state.maxProjects = data.maxProjects
			state.maxAudio = data.maxAudio
			state.maxImageSize = data.maxImageSize
			state.maxAudioSize = data.maxAudioSize
		}
	}
}

export default module
